import { render, staticRenderFns } from "./SubmitDocuments.vue?vue&type=template&id=48f5a9bc&scoped=true&"
import script from "./SubmitDocuments.vue?vue&type=script&lang=js&"
export * from "./SubmitDocuments.vue?vue&type=script&lang=js&"
import style0 from "./SubmitDocuments.vue?vue&type=style&index=0&id=48f5a9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f5a9bc",
  null
  
)

export default component.exports